import { Group, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { PublicationCardIdentifiers } from '@/module/Author/Publication/components/PublicationCardIdentifiers';
import { PublicationTitle } from '@/module/Author/Publication/components/PublicationTitle';

import { BdiList, LanguagePill, NoOfAuthors, PublicationPages, PublishedAtText } from '@feature/utils';

import { Chapter } from './../../model/ChapterTypes';
import classes from './ChapterCard.module.css';

export interface ChapterCardProps {
  chapter: Chapter;
  to?: string;
  onClick?: () => void;
}

export function ChapterCard({ chapter, to, onClick }: ChapterCardProps) {
  const { publishedAt, authors, language, noOfPages, publisher, startPage, endPage, identifiers, publisherType, bdis } =
    chapter;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      onClick={onClick}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="xs">
        <PublicationTitle publication={chapter} />
        <Group>
          {publisher && (
            <>
              <Text>
                {publisher.title} {publisherType?.name ? `(${publisherType.name})` : ''}
              </Text>
              <PublicationPages
                startPage={startPage}
                endPage={endPage}
                noOfPages={noOfPages}
              />
            </>
          )}
        </Group>
        <BdiList bdis={bdis} />
        <Group>
          <PublishedAtText
            date={publishedAt}
            size="sm"
            c="dimmed"
          />
          <NoOfAuthors authors={authors} />
        </Group>
        <Group>
          <LanguagePill language={language} />
          {identifiers && <PublicationCardIdentifiers identifiers={identifiers} />}
        </Group>
      </Stack>
    </Paper>
  );
}
